export function showEmptyCartModal() {
    setTimeout(function () {
        document.getElementById('emptycart-modal-trigger').click();
    }, 100);
}
